module.exports = __webpack_public_path__ + "67a65e6053722f869b3c674087d0ca46.png";